import React, { useEffect, useState, useRef } from "react";
import { io } from "socket.io-client";
import '../styles/VariableTable.css'; // стили отдельно

const socket = io('https://topkns.ru'); //was mykns.ru

const VariableTable = () => {
  const [variables, setVariables] = useState({});
  const changedRef = useRef({}); // хранит состояние "изменилось ли значение"

  useEffect(() => {
    socket.on("connect", () => {
      console.log("🔌 Подключено к серверу");
    });

    socket.on("var", ({ name, value }) => {
      setVariables((prev) => {
        if (prev[name] !== value) {
          changedRef.current[name] = true;
          setTimeout(() => {
            changedRef.current[name] = false;
            setVariables((vars) => ({ ...vars })); // триггер обновления
          }, 1000);
        }
        return { ...prev, [name]: value };
      });
    });

    socket.on("init", (vars) => {
      setVariables(vars);
    });

    return () => {
      socket.off("connect");
      socket.off("var");
      socket.off("init");
    };
  }, []);

  return (
    <div style={{ padding: "20px", fontFamily: "sans-serif" }}>
      <h1>Переменные от сервера</h1>
      <table>
        <thead>
          <tr>
            <th>Имя</th>
            <th>Значение</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(variables).map(([name, value]) => (
            <tr key={name} className={changedRef.current[name] ? "changed" : ""}>
              <td>{name}</td>
              <td>{value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default VariableTable;
